import React, { useContext, useState, useEffect, useRef } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import ProductContext from '@/product/context/product/productContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import ProductCommonContext from '@/product/context/common/commonContext'
import UserContext from '@/product/context/user/userContext'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import AuthContext from '@/product/context/auth/authContext'
import SettingContext from '@/product/context/setting/settingContext'
import Loaders from '@/product/components/molecules/Loaders'

import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'

const BulkListing = (props) => {
    const {
        bulkProjectAction,
        uploadXLSXFile,
        responseStatus: bulkUploadStatus,
        clearResponse: bulkUploadClear,
    } = useContext(ProductContext)
    const settingcontext = useContext(SettingContext)
    const { searchTableFetch, search_fetch_data } = settingcontext

    const [isLoading, setIsLoading] = useState(false)
    const { resetDropZone } = useContext(ProductCommonContext)
    const [reload, setReload] = useState(false)
    const [warehouseData, setWarehouseData] = useState({
        options: [],
        object: {},
    })
    // const [mapDataFields, setMapDataFields] = useState([])

    const {
        allCategory,
        allLocations,
        allCondition,
        alldata_all_dropdown,
        allConfigurationVariables,
    } = useContext(CustomCommonContext)
    const { user } = useContext(AuthContext)
    const { getAllUsers, all_users } = useContext(UserContext)
    const {
        getXLSXFile,
        responseStatus: responseStatusReport,
        clearResponse: clearResponseReport,
    } = useContext(ReportContext)

    const dynamicContext = useContext(DynamicContext)

    const { project_dynamicfields, getAllDynamicArray, dynamicValue } =
        dynamicContext

    const data = props.data
    const toggleFullScreenPopup = props.function

    const rawFieldsData = [
        // {
        //     id: 1,
        //     isRequired: true,
        //     colId: 1,
        //     label: 'Start date',
        //     placeholder: 'Enter Start date',
        //     type: 'datetime',
        //     name: 'date_added',
        // },
        {
            id: 1,
            isRequired: true,
            colId: 1,
            name: 'title',
            type: 'text',
            label: 'Inventory title',
            placeholder: 'Enter Inventory title',
        },
        {
            id: 2,
            isRequired: false,
            colId: 2,
            label: 'End Date',
            placeholder: 'Enter End Date',
            type: 'datetime',
            name: 'date_closed',
        },
        // {
        //     id: 5,
        //     isRequired: true,
        //     colId: 5,
        //     name: 'auction',
        //     label: 'Enable Offer',
        //     placeholder: 'Enable Offer',
        //     type: 'select',
        //     options: [
        //         { value: 1, show: 'Yes' },
        //         { value: 0, show: 'No' },
        //     ],
        // },
        // {
        //     id: 4,
        //     isRequired: false,
        //     colId: 4,
        //     name: 'featured',
        //     label: 'Featured',
        //     placeholder: 'Featured',
        //     type: 'select',
        //     options: [
        //         { value: 1, show: 'Yes' },
        //         { value: 0, show: 'No' },
        //     ],
        // },
        // {
        //     id: 6,
        //     isRequired: true,
        //     colId: 6,
        //     name: 'show_reserve',
        //     label: 'Show Reserve',
        //     placeholder: 'Show Reserve',
        //     type: 'select',
        //     options: [
        //         { value: 1, show: 'Yes' },
        //         { value: 0, show: 'No' },
        //     ],
        // },
        // {
        //     id: 7,
        //     isRequired: true,
        //     colId: 7,
        //     name: 'sprice',
        //     type: 'decimal',
        //     label: 'Start Price',
        //     placeholder: 'Enter your Start price',
        // },
        // {
        //     id: 8,
        //     isRequired: true,
        //     colId: 8,
        //     name: 'rprice',
        //     type: 'decimal',
        //     label: 'Reserve Price',
        //     placeholder: 'Enter your Reserve price',
        // },
        // {
        //     id: 9,
        //     isRequired: true,
        //     colId: 9,
        //     name: 'buynow',
        //     label: 'Enable Buy Now',
        //     placeholder: 'Enable Buy Now',
        //     type: 'select',
        //     options: [
        //         { value: 1, show: 'Yes' },
        //         { value: 0, show: 'No' },
        //     ],
        // },
        // {
        //     id: 10,
        //     isRequired: true,
        //     colId: 10,
        //     name: 'show_buynow',
        //     label: 'Show Buy Now',
        //     placeholder: 'Show Buy Now',
        //     type: 'select',
        //     options: [
        //         { value: 1, show: 'Yes' },
        //         { value: 0, show: 'No' },
        //     ],
        // },
        {
            id: 3,
            isRequired: false,
            colId: 3,
            name: 'bprice',
            type: 'decimal',
            label: 'Buy Now Price',
            placeholder: 'Enter buy now price',
        },
        {
            id: 4,
            isRequired: false,
            colId: 4,
            name: 'asin_price',
            type: 'decimal',
            label: 'Retail Price',
            placeholder: 'Enter Retail Price',
        },
        {
            id: 5,
            isRequired: true,
            colId: 5,
            name: 'qty',
            type: 'number',
            label: 'Quantity',
            placeholder: 'Enter Quantity',
        },
        {
            id: 6,
            isRequired: true,
            colId: 6,
            name: 'desc_proc',
            type: 'text',
            label: 'Description',
            placeholder: 'Enter your Description',
        },
        // {
        //     id: 27,
        //     isRequired: true,
        //     colId: 27,
        //     name: 'location_id',
        //     type: 'select',
        //     label: 'Location',
        //     placeholder: 'Select Location',
        //     options: allLocations
        //         .filter(
        //             (value) =>
        //                 (user.emp_location || '')
        //                     .split(',')
        //                     .includes(String(value.id)) && value.active === 1
        //         )
        //         .map((location) => ({
        //             show: location.description || location.name,
        //             value: location.id,
        //         })),
        // },
        {
            id: 7,
            isRequired: true,
            colId: 7,
            name: 'conditionTypeId',
            type: 'select',
            label: 'Condition',
            placeholder: 'Select Condition',
            options: alldata_all_dropdown
                .filter(
                    (value) =>
                        value.variable === 'conditionTypeId' &&
                        value.level === 0
                )
                .map((item) => {
                    return {
                        show: item.description,
                        value: item.id,
                    }
                }),
        },
        {
            id: 8,
            isRequired: true,
            colId: 8,
            name: 'category',
            type: 'select',
            label: 'Category',
            placeholder: 'Select Category',
            options: allCategory
                .filter((value) => value.active === 1 && value.level === 0)
                .map((item) => {
                    return {
                        show: item.description,
                        value: item.id,
                    }
                }),
        },
        // {
        //     id: 16,
        //     isRequired: false,
        //     colId: 16,
        //     name: 'sub_category',
        //     type: 'select',
        //     label: 'Sub Category',
        //     placeholder: 'Select Sub Category',
        //     options: allCategory
        //         .filter((value) => value.active === 1 && value.level === 1)
        //         .map((item) => {
        //             let valueChanged = {}
        //             valueChanged.show = item.description
        //             valueChanged.value = item.id
        //             return valueChanged
        //         }),
        // },
        {
            id: 9,
            isRequired: false,
            colId: 9,
            name: 'external_url',
            type: 'enforcetext',
            label: 'Product Link',
            placeholder: 'Enter Product Link',
        },
        {
            id: 10,
            isRequired: false,
            colId: 10,
            name: 'item_id',
            type: 'enforcetext',
            label: 'Item ID',
            placeholder: 'Enter Item ID',
        },
        {
            id: 11,
            isRequired: false,
            colId: 11,
            name: 'truck_code',
            type: 'enforcetext',
            label: 'Truck Code',
            placeholder: 'Enter Truck Code',
        },
        {
            id: 12,
            isRequired: false,
            colId: 12,
            name: 'size',
            type: 'enforcetext',
            label: 'Size',
            placeholder: 'Enter Size',
        },
        {
            id: 13,
            isRequired: false,
            colId: 13,
            name: 'mpn',
            type: 'text',
            label: 'SKU',
            placeholder: 'Enter SKU',
        },
        {
            id: 14,
            isRequired: false,
            colId: 14,
            name: 'scan_lpn_number',
            type: 'enforcetext',
            label: 'LPN Number',
            placeholder: 'Enter LPN Number',
        },
        {
            id: 15,
            isRequired: false,
            colId: 15,
            name: 'asin',
            type: 'enforcetext',
            label: 'ASIN',
            placeholder: 'Enter ASIN',
        },
        {
            id: 16,
            isRequired: false,
            colId: 16,
            name: 'bin_location',
            type: 'enforcetext',
            label: 'Bin Location',
            placeholder: 'Enter Location in Facility',
        },
        {
            id: 17,
            isRequired: false,
            colId: 17,
            name: 'upc_id',
            type: 'number',
            label: 'UPC Code',
            placeholder: 'Enter UPC Code',
        },
        {
            id: 18,
            isRequired: false,
            colId: 18,
            name: 'brand',
            type: 'enforcetext',
            label: 'Brand',
            placeholder: 'Enter Brand',
        },
        // {
        //     id: 27,
        //     isRequired: false,
        //     colId: 27,
        //     name: 'warehouse_name',
        //     type: 'text',
        //     label: 'Warehouse',
        //     placeholder: 'Enter Warehouse',
        // },
        // {
        //     id: 27,
        //     isRequired: false,
        //     colId: 27,
        //     name: 'barcode',
        //     type: 'text',
        //     label: 'Barcode',
        //     placeholder: 'Enter Barcode',
        // },
        // {
        //     id: 27,
        //     isRequired: false,
        //     colId: 27,
        //     name: 'conatiner',
        //     type: 'text',
        //     label: 'Container',
        //     placeholder: 'Enter Container',
        // },
        // {
        //     id: 27,
        //     isRequired: false,
        //     colId: 27,
        //     name: 'pallet',
        //     type: 'text',
        //     label: 'Pallet',
        //     placeholder: 'Enter Pallet',
        // },
        {
            id: 19,
            isRequired: false,
            colId: 19,
            label: 'Keyword Tags',
            type: 'enforcetext',
            placeholder: 'Enter Keyword Tags',
            name: 'keywords',
        },
        {
            id: 20,
            isRequired: true,
            colId: 20,
            label: 'Images Link (Comma Separated)',
            type: 'image_url',
            placeholder: 'Enter Image Links',
            name: 'image_url_list',
        },
        // {
        //     id: 12,
        //     isRequired: false,
        //     colId: 12,
        //     name: 'unit_measure',
        //     type: 'select',
        //     label: 'Unit of Measure',
        //     placeholder: 'Select Unit of Measure',
        //     options: alldata_all_dropdown
        //         .filter((value) => value.variable === 'unit_measure' && value.level === 0)
        //         .map((item) => {
        //             let valueChanged = {}
        //             valueChanged.show = item.description
        //             valueChanged.value = item.id
        //             return valueChanged
        //         }),
        // },
        // {
        //     id: 15,
        //     isRequired: false,
        //     colId: 15,
        //     name: 'location_type',
        //     type: 'select',
        //     label: 'Location Type',
        //     placeholder: 'Select your Location type',
        //     options: [
        //         { value: 1, show: 'Surplus Services Location' },
        //         { value: 2, show: 'Agency Locations' },
        //     ],
        // },
        // {
        //     id: 17,
        //     isRequired: false,
        //     colId: 17,
        //     name: 'year',
        //     type: 'year',
        //     label: 'Year',
        //     placeholder: 'Enter year',
        // },
        // {
        //     id: 18,
        //     isRequired: false,
        //     colId: 18,
        //     name: 'manufacturer',
        //     type: 'text',
        //     label: 'Manufacturer',
        //     placeholder: 'Enter Manufacturer',
        // },
        // {
        //     id: 19,
        //     isRequired: false,
        //     colId: 19,
        //     name: 'model_no',
        //     type: 'text',
        //     label: 'Model Number',
        //     placeholder: 'Enter model number',
        // },
        // {
        //     id: 20,
        //     isRequired: false,
        //     colId: 20,
        //     name: 'serial_no',
        //     type: 'text',
        //     label: 'Serial / Vin #',
        //     placeholder: 'Enter Serial / Vin #',
        // },
        // {
        //     id: 21,
        //     isRequired: false,
        //     colId: 21,
        //     name: 'mileage',
        //     type: 'text',
        //     label: 'Mileage',
        //     placeholder: 'Enter Mileage',
        // },
        // {
        //     id: 22,
        //     isRequired: false,
        //     colId: 22,
        //     name: 'notes_listing',
        //     type: 'text',
        //     label: 'Notes',
        //     placeholder: 'Enter Notes',
        // },
        // {
        //     id: 23,
        //     isRequired: false,
        //     colId: 23,
        //     name: 'asset_no',
        //     type: 'text',
        //     label: 'Asset #',
        //     placeholder: 'Enter asset #',
        // },
        // {
        //     id: 24,
        //     isRequired: false,
        //     colId: 24,
        //     name: 'unit_no',
        //     type: 'text',
        //     label: 'Unit #',
        //     placeholder: 'Enter unit #',
        // },
        // {
        //     id: 25,
        //     isRequired: false,
        //     colId: 25,
        //     name: 'acq_cost',
        //     type: 'decimal',
        //     label: 'Acq. cost',
        //     placeholder: 'Enter acq cost',
        // },
        // {
        //     id: 26,
        //     isRequired: false,
        //     colId: 26,
        //     name: 'acq_date',
        //     type: 'date',
        //     label: 'Acq. date',
        //     placeholder: 'Enter acq date',
        // },
        // {
        //     id: 28,
        //     isRequired: true,
        //     colId: 28,
        //     name: 'sales_tax_check',
        //     label: 'Enable Sales Tax',
        //     placeholder: 'Enable Sales Tax',
        //     type: 'select',
        //     options: [
        //         { value: 1, show: 'Yes' },
        //         { value: 0, show: 'No' },
        //     ],
        // },
        // {
        //     id: 29,
        //     isRequired: true,
        //     colId: 29,
        //     name: 'transit_tax_check',
        //     type: 'select',
        //     label: 'Enable Transit Tax',
        //     placeholder: 'Enable Transit Tax',
        //     options: [
        //         { value: 1, show: 'Yes' },
        //         { value: 0, show: 'No' },
        //     ],
        // },
        // {
        //     id: 30,
        //     isRequired: true,
        //     colId: 30,
        //     name: 'excise_tax_check',
        //     type: 'select',
        //     label: 'Enable Excise Tax',
        //     placeholder: 'Enable Excise Tax',
        //     options: [
        //         { value: 1, show: 'Yes' },
        //         { value: 0, show: 'No' },
        //     ],
        // },
        // {
        //     id: 31,
        //     isRequired: false,
        //     colId: 31,
        //     label: 'External Video',
        //     placeholder: 'External Video',
        //     type: 'select',
        //     name: 'video_type',
        //     options: [
        //         { value: 1, show: 'Yes' },
        //         { value: 0, show: 'No' },
        //     ],
        // },
        // {
        //     id: 32,
        //     isRequired: false,
        //     colId: 32,
        //     label: 'Video Url',
        //     type: 'text',
        //     placeholder: 'Enter your video url',
        //     name: 'video',
        // },
        // {
        //     id: 33,
        //     isRequired: false,
        //     colId: 33,
        //     label: 'Damaged',
        //     placeholder: 'Is Damaged',
        //     type: 'select',
        //     name: 'damaged',
        //     options: [
        //         { value: 1, show: 'Yes' },
        //         { value: 0, show: 'No' },
        //     ],
        // },
        // {
        //     id: 34,
        //     isRequired: false,
        //     colId: 34,
        //     label: 'Damage Details',
        //     type: 'text',
        //     placeholder: 'Enter damage details',
        //     name: 'damaged_notes',
        // },
        // {
        //     id: 35,
        //     isRequired: false,
        //     colId: 35,
        //     label: 'Images Link (Comma Seperated)',
        //     type: 'image_url',
        //     placeholder: 'Enter Image Links',
        //     name: 'image_url_list',
        // },
    ]

    useEffect(() => {
        getAllDynamicArray(
            {
                page: 1,
                limit: 20,
                order: 'asc',
                orderby: 'df.show_order',
                table: 'dynamic_fields',
                filters: {
                    action: {
                        value: 1,
                        type: 'in',
                        field: 'df.view_page',
                    },
                    active: {
                        value: 1,
                        type: 'in',
                        field: 'df.active',
                    },
                },
            },
            'listingBulkUpload'
        )
    }, [props?.data])

    const addSequentialIdsWithMap = (arrayOfObjects) => {
        return arrayOfObjects.map((obj, index) => ({
            ...obj,
            id: index + 1,
            colId: index + 1,
        }))
    }

    const mapDataFields = addSequentialIdsWithMap(rawFieldsData)

    useEffect(() => {
        searchTableFetch(
            {
                primaryTable: 'locations',
                limit: 1000,
                fetch: [
                    'id',
                    'warehouse_id',
                    'app_id',
                    'name',
                    'active',
                    'user_settings_id',
                    'supply_id',
                ],
                filters: {
                    active: {
                        value: 1,
                        type: 'in',
                        field: 'l.active',
                    },
                },
            },
            'bulkListing'
        )
    }, [])

    useEffect(() => {
        if (
            search_fetch_data?.records?.length &&
            search_fetch_data?.from === 'bulkListing'
        ) {
            const processedData = search_fetch_data.records
                .filter((location) =>
                    (user.emp_location || '')
                        .split(',')
                        .includes(String(location.id))
                )
                .reduce(
                    (acc, location) => {
                        const { id, name, warehouse_id } = location
                        acc.options.push({
                            show: name,
                            value: id,
                        })
                        acc.object[id] = location
                        return acc
                    },
                    { options: [], object: {} }
                )
            setWarehouseData(processedData)
        }
    }, [search_fetch_data])

    // useEffect(() => {
    //     console.log('i am bulk upload here', dynamicValue)
    //     if (
    //         dynamicValue?.from === 'listingBulkUpload' &&
    //         dynamicValue.records.length
    //     ) {
    //         let dynamicValues = []
    //         let dynamicValueAssign = dynamicValue.records
    //         dynamicValueAssign
    //             .filter(
    //                 (data) =>
    //                     data.active === 1 &&
    //                     data.name !== 'asin' &&
    //                     data.name !== 'home_depot' &&
    //                     data.name !== 'upc_id' &&
    //                     !props?.filterElements.includes(data.name)
    //             )
    //             .map((buscat) => {
    //                 if (buscat?.type === 'checkbox') {
    //                     dynamicValues.push({
    //                         id: buscat?.id,
    //                         isRequired: buscat?.is_required ? true : false,
    //                         colId: buscat?.id,
    //                         label: buscat?.label,
    //                         placeholder: buscat?.placeholder,
    //                         type: 'select',
    //                         name: buscat?.name,
    //                         options: [
    //                             { value: 1, show: 'Yes' },
    //                             { value: 0, show: 'No' },
    //                         ],
    //                     })
    //                 } else if (
    //                     buscat?.type === 'select' &&
    //                     parseInt(buscat.location, 10) === 1
    //                 ) {
    //                     dynamicValues.push({
    //                         id: buscat?.id,
    //                         isRequired: buscat?.is_required ? true : false,
    //                         colId: buscat?.id,
    //                         label: buscat?.label,
    //                         placeholder: buscat?.placeholder,
    //                         type: buscat?.type,
    //                         name: buscat?.name,
    //                         options: props?.customLocationFilter?.key
    //                             ? allLocations
    //                                   ?.filter(
    //                                       (value) =>
    //                                           value.active === 1 &&
    //                                           value[
    //                                               props?.customLocationFilter
    //                                                   ?.key
    //                                           ] ===
    //                                               props?.customLocationFilter
    //                                                   ?.value
    //                                   )
    //                                   .map((location) => {
    //                                       let locationChanged = {}
    //                                       locationChanged.show =
    //                                           props?.customDescription
    //                                               ? location[
    //                                                     props?.customDescription
    //                                                 ]?.replace(/"/g, '')
    //                                               : location.description?.replace(
    //                                                     /"/g,
    //                                                     ''
    //                                                 )
    //                                       locationChanged.value = location.id
    //                                       return locationChanged
    //                                   })
    //                             : allLocations
    //                                   ?.filter((value) => value.active === 1)
    //                                   .map((location) => {
    //                                       let locationChanged = {}
    //                                       locationChanged.show =
    //                                           props?.customDescription
    //                                               ? location[
    //                                                     props?.customDescription
    //                                                 ]?.replace(/"/g, '')
    //                                               : location.description?.replace(
    //                                                     /"/g,
    //                                                     ''
    //                                                 )
    //                                       locationChanged.value = location.id
    //                                       return locationChanged
    //                                   }),
    //                     })
    //                 } else if (
    //                     buscat.type === 'select' &&
    //                     parseInt(buscat.sub_select, 10) !== 1 &&
    //                     buscat.location !== 1
    //                 ) {
    //                     dynamicValues.push({
    //                         id: buscat?.id,
    //                         isRequired: buscat?.is_required ? true : false,
    //                         colId: buscat?.id,
    //                         label: buscat?.label,
    //                         placeholder: buscat?.placeholder,
    //                         type: buscat?.type,
    //                         name: buscat?.name,
    //                         options: alldata_all_dropdown
    //                             .filter(
    //                                 (value) =>
    //                                     value.variable === buscat.name &&
    //                                     value.level === 0
    //                             )
    //                             .sort((a, b) => a.show_order - b.show_order)
    //                             .map((item) => {
    //                                 let valueChanged = {}
    //                                 valueChanged.show =
    //                                     item.description?.replace(/"/g, '')
    //                                 valueChanged.value = buscat.diff_value
    //                                     ? item.value
    //                                     : item.id
    //                                 return valueChanged
    //                             }),
    //                     })
    //                 } else {
    //                     dynamicValues.push({
    //                         id: buscat?.id,
    //                         isRequired: buscat?.is_required ? true : false,
    //                         colId: buscat?.id,
    //                         label: buscat?.label,
    //                         placeholder: buscat?.placeholder,
    //                         type: ['date_added', 'date_closed'].includes(
    //                             buscat?.name
    //                         )
    //                             ? 'datetime'
    //                             : ['sprice', 'bprice', 'rprice'].includes(
    //                                     buscat?.name
    //                                 )
    //                               ? 'decimal'
    //                               : buscat?.type === 'number'
    //                                 ? 'number'
    //                                 : 'text',
    //                         name: buscat?.name,
    //                     })
    //                 }
    //             })
    //         if (props?.imageUpload) {
    //             dynamicValues = dynamicValues.filter(
    //                 (item) => item?.name !== 'uploadimages'
    //             )
    //             dynamicValues.push({
    //                 id: 35,
    //                 isRequired: false,
    //                 colId: 35,
    //                 label: 'Images Link (Comma Seperated)',
    //                 type: 'image_url',
    //                 placeholder: 'Enter Image Links',
    //                 name: 'image_url_list',
    //             })
    //         }
    //         setMapDataFields(addSequentialIdsWithMap(dynamicValues))
    //     }
    // }, [dynamicValue])

    const validationArray = Yup.object({
        // categoryTypeId: Yup.string(),
        // subCategoryTypeId: Yup.string(),
        warehouse_id: Yup.string().required(
            'Please select one of the warehouse'
        ),
        uploadFiles: Yup.array().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            categoryTypeId: '',
            subCategoryTypeId: '',
            uploadFiles: [],
            conditionTypeId: '',
            dataFields: [],
            warehouse_id: '',
            preFillFields: {
                sprice: 1,
                rprice: 1,
                wprice: 1,
                warehouse_name: '',
                warehouse_id: '',
                status: 'live',
                is_approved: 0,
                market_status: 'draft',
                pickup_deadline_days:
                    allConfigurationVariables &&
                    allConfigurationVariables?.schedule_pickup_end_date
                        ? allConfigurationVariables.schedule_pickup_end_date
                        : 7,
                supply:
                    allConfigurationVariables?.appsheet_supply ||
                    'ytIQC38waN49qtURjTrBA6',
                created_by_external:
                    allConfigurationVariables?.appsheet_user ||
                    '4gBLo0hwKR4ZMs34k_p4xf',
            },
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            values.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            values.withTime = true
            const latestMapDataFields = [
                ...mapDataFields,
                {
                    id: mapDataFields.length + 1,
                    isRequired: false,
                    colId: mapDataFields.length + 1,
                    name: 'row_id',
                    type: 'text',
                    label: 'ROW ID',
                    placeholder: 'Enter ROW ID',
                },
                // {
                //     id: mapDataFields.length + 2,
                //     isRequired: false,
                //     colId: mapDataFields.length + 2,
                //     name: 'sub_category',
                //     type: 'text',
                //     label: 'SUB CATEGORY',
                //     placeholder: 'Enter SUB CATEGORY',
                // },
            ]
            values.dataFields = latestMapDataFields
            values.image_url = true
            values.preFillFields.pickup_deadline_days =
                allConfigurationVariables &&
                allConfigurationVariables?.schedule_pickup_end_date
                    ? allConfigurationVariables.schedule_pickup_end_date
                    : 7
            if (values?.warehouse_id) {
                values.preFillFields.location = values.warehouse_id
                values.preFillFields.location_id = values.warehouse_id
                // values.preFillFields.warehouse_id =
                //     warehouseData.object[values.warehouse_id]?.warehouse_id ||
                //     values.warehouse_id
                values.preFillFields.warehouse_id = values.warehouse_id
                warehouseData.object[values.warehouse_id?.name] || ''
                values.preFillFields.warehouse_name =
                    warehouseData.object[values.warehouse_id]?.name
                values.preFillFields.supply =
                    warehouseData.object[values.warehouse_id]?.supply_id
                values.preFillFields.user_settings_id =
                    warehouseData.object[values.warehouse_id]?.user_settings_id
                values.preFillFields.processor_name = `${
                    user?.emp_firstname || ''
                } ${user?.emp_lastname || ''}`
            }
            console.log(`uploadXLSXFile values `, values)
            uploadXLSXFile(values, true, null, 'uploadXLSXFileResponse')
        },
    })

    useEffect(() => {
        return () => {
            setIsLoading(false)
            formik.setFieldValue('dataFields', mapDataFields)
        }
    }, [])

    const formSubmit = (data) => {
        formik.values.market_status = data
        formik.submitForm().then(setIsLoading(false)).catch(setIsLoading(false))
    }

    useEffect(() => {
        if (responseStatusReport?.status === 'success') {
            console.log('report here download ', responseStatusReport)
            window.open(responseStatusReport?.data?.filePath)
        }
        clearResponseReport()
    }, [responseStatusReport])
    const sessionTimeoutShown = useRef(false)

    useEffect(() => {
        console.log('report here upload ', bulkUploadStatus)
        if (bulkUploadStatus) {
            if (
                bulkUploadStatus?.status === 'error' &&
                bulkUploadStatus?.message === 'Session timed out!' &&
                !sessionTimeoutShown.current
            ) {
                sessionTimeoutShown.current = true
            }
            if (
                bulkUploadStatus?.status === 'success' &&
                bulkUploadStatus?.from === 'uploadXLSXFileResponse'
            ) {
                toggleFullScreenPopup(false, 'refresh')
            }

            formik.setValues(formik.initialValues)
            formik.resetForm()
            bulkUploadClear()
            setIsLoading(false)
        }
    }, [bulkUploadStatus])

    const downLoadSample = () =>
        window.open(`${global.site_url}/samples/products.csv`)

    const productListing = [
        {
            type: 'uploadDropZone',
            formik: formik,
            name: 'uploadFiles',
            titleText: 'Upload XLSX document *',
            class: 'col-12',
            folder: 'temp',
            multiple: false,
            accept: '.xlsx',
        },
        {
            label: 'Warehouse',
            placeholder: 'Select Warehouse',
            type: 'select',
            class: 'col-sm-12 col-12',
            options: warehouseData?.options || [],
            defaultOptionValue: 'Select Warehouse',
            name: 'warehouse_id',
            formik: formik,
        },
        // {
        //     label: 'Category',
        //     placeholder: 'Select category',
        //     type: 'select',
        //     class: 'col-sm-6 col-12',
        //     options: allCategory
        //         .filter((maincat) => maincat.active === 1 && maincat.level === 0)
        //         .map((maincat) => {
        //             let categoryChanged = {}
        //             categoryChanged.show = maincat.description
        //             categoryChanged.value = maincat.id
        //             return categoryChanged
        //         }),
        //     defaultOptionValue: 'Select a Category',
        //     name: 'categoryTypeId',
        //     formik: formik,
        // },
        // {
        //     label: 'Sub-Category',
        //     placeholder: 'Select sub-category',
        //     type: 'select',
        //     class: 'col-sm-6 col-12',
        //     options: allCategory
        //         .filter((subcat) =>
        //             subcat.active === 1 && formik.values.categoryTypeId.length
        //                 ? formik.values.categoryTypeId.includes(subcat.level_id)
        //                 : true && subcat.level === 1,
        //         )
        //         .map((subcat) => {
        //             let subCategoryChanged = {}
        //             subCategoryChanged.show = subcat.description
        //             subCategoryChanged.value = subcat.id
        //             return subCategoryChanged
        //         }),
        //     defaultOptionValue: 'Select a Sub Category',
        //     name: 'subCategoryTypeId',
        //     formik: formik,
        // },
        // {
        //     label: 'Condition',
        //     placeholder: 'Select condition',
        //     type: 'select',
        //     class: 'col-sm-6 col-12',
        //     options: allCondition
        //         .filter((value) => value.active === 1)
        //         .map((location) => {
        //             let conditionChanged = {}
        //             conditionChanged.show = location.description
        //             conditionChanged.value = location.id
        //             return conditionChanged
        //         }),
        //     defaultOptionValue: 'Select a Condition',
        //     name: 'conditionTypeId',
        //     formik: formik,
        // },
    ]

    return (
        <FullScreenPopup
            modaltitle={`ADD NEW BULK LISTING`}
            open={data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            <div className="addBulkUpload fspLoaderContainer">
                <div className="fspBody">
                    {isLoading && (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    )}
                    <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                        <div className="row">
                            <div className="col-md-5 col-12 mb-4">
                                <h4 className="fspTitle">
                                    Bulk Upload Instructions
                                </h4>
                                <ul>
                                    <li>Download the sample file.</li>
                                    <li>
                                        Don&apos;t edit the header names .
                                        Please give the appropriate values for
                                        each fields.
                                    </li>
                                    {/* <li>
                                        You have to give proper categoryTypeId.
                                        <ol>
                                            If you want to add the additional categories please
                                            mention the IDs of those in comma separated. Ex : 2,3,4
                                            .
                                        </ol>
                                    </li>
                                    <li>
                                        You have to give proper subCategoryTypeId.
                                        <ol>
                                            If you want to add the additional sub categories please
                                            mention the IDs of those in comma separated. Ex : 2,3,4
                                            .
                                        </ol>
                                    </li>
                                    <li>You have to give proper conditionTypeId.</li>
                                    <li>
                                        Below are the fields you can enable and disable them by
                                        giving 0 or 1 , that means it should have 0 or 1
                                        <ol>auction, buynow.</ol>
                                    </li> */}
                                    <li>
                                        Below are the fields required.
                                        <ul>
                                            <li>Inventory title</li>
                                            {/* <li>
                                                {`End Date - `}
                                                <br />
                                                {`(MM/DD/YYYY HH:MM:SS AM/PM)`}
                                            </li> */}
                                            <li>Quantity</li>
                                            <li>Description</li>
                                            <li>Condition</li>
                                            <li>Category</li>
                                            <li>{`Image Link (Comma Separated URLs)`}</li>
                                            <li>{`Item(s) Warehouse`}</li>
                                            {/* <li>
                                                sprice - must be less than
                                                rprice
                                            </li>
                                            <li>
                                                rprice - must be greater sprice
                                                and less than bprice
                                            </li>
                                            <li>
                                                bprice - must be greater or
                                                equal rprice
                                            </li> */}
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-7 col-12">
                                <div className="row">
                                    <div className="col-12">
                                        <h4 className="fspTitle">
                                            Upload XLSX document
                                        </h4>
                                    </div>
                                    {Object.values(mapData(productListing))}
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <h5 className="fspSubTitle">Review</h5>
                                        <table className="table text-left">
                                            <tbody>
                                                <tr>
                                                    <th scope="row">
                                                        Warehouse ID:
                                                    </th>
                                                    <td className="text-right">
                                                        {formik?.values
                                                            ?.warehouse_id ||
                                                            'N/A'}
                                                    </td>
                                                </tr>
                                                {/* <tr>
                                                    <th scope="row">Category Type Id:</th>
                                                    <td className="text-right">
                                                        {formik.values.categoryTypeId
                                                            ? formik.values.categoryTypeId
                                                            : 'N/A'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Sub-category Type Id:</th>
                                                    <td className="text-right">
                                                        {formik.values.subCategoryTypeId
                                                            ? formik.values.subCategoryTypeId
                                                            : 'N/A'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Condition Type Id:</th>
                                                    <td className="text-right">
                                                        {formik.values.conditionTypeId
                                                            ? formik.values.conditionTypeId
                                                            : 'N/A'}
                                                    </td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                    <SecondaryButton
                                        id="bulk_download"
                                        type="button"
                                        onClick={() => {
                                            getXLSXFile({
                                                fileName: 'bulk_products',
                                                sheetName:
                                                    'Product Bulk Upload',
                                                data: mapDataFields,
                                                dummyData: 10,
                                                ignoreFields: [
                                                    'uploadimages',
                                                    'image_url_list',
                                                    'image_url',
                                                    'desc_proc',
                                                ],
                                            })
                                        }}
                                        label="Download Sample"
                                    />
                                    <PrimaryButton
                                        id="listing_bulk_submit"
                                        onClick={() => {
                                            formSubmit('draft')
                                        }}
                                        type="button"
                                        label="Submit"
                                        disabled={
                                            formik.isSubmitting || isLoading
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default BulkListing
